export default "__VITE_ASSET__IXtRB0W5__"